var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement, Fragment, isValidElement, useMemo, useRef, } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { HorizontalLegend, Line, StepperBase, VerticalLegend } from './styled';
import { StepHeader } from './StepHeader';
import { useSetFocusOnActiveStepChanged } from './helpers/useSetFocusOnActiveStepChanged';
function Stepper(_a) {
    var { active, skipped = [], orientation = 'horizontal', breakpoint = 768, children } = _a, props = __rest(_a, ["active", "skipped", "orientation", "breakpoint", "children"]);
    const screen = useWindowSize();
    const stepsProps = useMemo(() => Children.map(children, (child) => isValidElement(child) && child.props).filter(Boolean), [children]);
    const activeStep = useMemo(() => {
        const activeChild = Children.toArray(children)[active];
        return isValidElement(activeChild)
            ? cloneElement(activeChild, { title: undefined })
            : activeChild;
    }, [active, children]);
    const stepperRef = useRef(null);
    useSetFocusOnActiveStepChanged(active, stepperRef.current);
    const verticalView = useMemo(() => (React.createElement(StepperBase, Object.assign({}, props, { ref: stepperRef }), stepsProps.map((stepProps, index) => {
        const isLast = index === stepsProps.length - 1;
        const { title, caption, legendProps } = stepProps;
        const shouldShowLine = !isLast && active !== index;
        return (React.createElement(VerticalLegend, { key: `legend-${stepProps.title}` },
            React.createElement(StepHeader, { title: title, caption: caption, "$legendProps": legendProps, activeStepIndex: active, stepIndex: index, isLast: index === stepsProps.length - 1, orientation: orientation, isSkipped: skipped.includes(index), breakpoint: breakpoint }),
            active === index && activeStep,
            shouldShowLine && React.createElement(Line, null)));
    }))), [props, activeStep, active, stepsProps, orientation, skipped, breakpoint]);
    const horizontalView = useMemo(() => (React.createElement(StepperBase, Object.assign({}, props, { ref: stepperRef }),
        React.createElement(HorizontalLegend, { "$stepCount": stepsProps.length }, stepsProps.map((stepProps, index) => {
            const { title, caption, legendProps } = stepProps;
            return (React.createElement(Fragment, { key: `legend-${stepProps.title}` },
                React.createElement(StepHeader, { title: title, caption: caption, "$legendProps": legendProps, activeStepIndex: active, stepIndex: index, isLast: index === stepsProps.length - 1, orientation: orientation, isSkipped: skipped.includes(index), breakpoint: breakpoint })));
        })),
        activeStep)), [props, activeStep, stepsProps, orientation, skipped, active, breakpoint]);
    if (orientation === 'horizontal') {
        return horizontalView;
    }
    if (orientation === 'vertical') {
        return verticalView;
    }
    if (screen.width < breakpoint) {
        return verticalView;
    }
    return horizontalView;
}
export { Step } from './Step';
export { default as useStepper } from './useStepper';
export default Stepper;
